import { flip, offset, shift, size } from '@floating-ui/react-dom';
import { pxToRem } from 'modules/v2/foundation/spacing';
const PADDING = 10;
export const getFloatingPositionMiddleware = (options) => [
    flip(),
    shift({ padding: PADDING }),
    offset({ mainAxis: options.offset === undefined ? 2 : options.offset }),
    size({
        padding: PADDING,
        apply({ availableHeight, availableWidth, elements }) {
            Object.assign(elements.floating.style, {
                maxHeight: pxToRem(availableHeight),
                maxWidth: pxToRem(availableWidth),
            });
        },
    }),
];
export const defaultFloatingPositionMiddleware = getFloatingPositionMiddleware({});
/**
 * useContextPosition middleware to make the floating element the same
 * size as the target element.
 */
export function parentWidth() {
    return size({
        apply({ elements, rects }) {
            Object.assign(elements.floating.style, {
                minWidth: pxToRem(rects.reference.width),
                maxWidth: pxToRem(rects.reference.width),
            });
        },
    });
}
